import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createMediaMTXWebRTCReader } from "Config/migrasiReader";
import { handleError, handleSuccess } from "Helper";

// Initial state Redux
const initialState = {
  streams: {},
  loadingStates: {},
  errorStates: {},
  trackReceived: {}, // Menyimpan apakah track sudah diterima
};

// Thunk untuk memulai streaming kamera menggunakan WebRTC
export const initializeStream = createAsyncThunk(
  "mediaMTX/initializeStream",
  async (camera, { rejectWithValue, dispatch }) => {
    try {
      const reader = createMediaMTXWebRTCReader({
        url: new URL("whep", `${camera}/query`),

        onError: (err) => {
          console.error("Streaming error:", err);
          dispatch(setErrorState({ camera, isError: true }));
          dispatch(setLoadingState({ camera, isLoading: false }));
        },

        onTrack: (evt) => {
          console.log(`Track received for ${camera}`, evt);
          dispatch(setErrorState({ camera, isError: false }));
          dispatch(setLoadingState({ camera, isLoading: false }));
        },
      });

      return { camera, reader };
    } catch (error) {
      // handleError(error);
      return rejectWithValue(error.message || "Streaming failed");
    }
  }
);

// Slice Redux untuk mengelola state streaming
const checkMediaMTXSlice = createSlice({
  name: "checkMediaMTX",
  initialState,
  reducers: {
    stopStream: (state, action) => {
      const camera = action.payload;
      if (state.streams[camera]) {
        state.streams[camera].close(); // Menutup koneksi WebRTC
        delete state.streams[camera];
      }
      state.loadingStates[camera] = false;
      state.errorStates[camera] = false;
      state.trackReceived[camera] = false;
    },
    setStreamError: (state, action) => {
      const { camera, error } = action.payload;
      state.errorStates[camera] = error;
      state.loadingStates[camera] = false;
    },
    setTrackReceived: (state, action) => {
      const { camera, received } = action.payload;
      state.trackReceived[camera] = received;
      state.loadingStates[camera] = false;
    },
    setLoadingState: (state, action) => {
      const { camera, isLoading } = action.payload;
      state.loadingStates[camera] = isLoading;
    },
    setErrorState: (state, action) => {
      const { camera, isError } = action.payload;
      state.errorStates[camera] = isError;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(initializeStream.pending, (state, action) => {
        const camera = action.meta.arg;
        state.loadingStates[camera] = true;
        state.errorStates[camera] = false;
        state.trackReceived[camera] = false;
      })
      .addCase(initializeStream.fulfilled, (state, action) => {
        const { camera, reader } = action.payload;
        state.streams[camera] = reader;
        state.loadingStates[camera] = false;
        // handleSuccess(`Streaming for ${camera} started successfully.`);
      })
      .addCase(initializeStream.rejected, (state, action) => {
        const camera = action.meta.arg;
        state.loadingStates[camera] = false;
        state.errorStates[camera] = true;
        // console.error(`Streaming for ${camera} failed:`, action.payload);
      });
  },
});

export const {
  stopStream,
  setStreamError,
  setTrackReceived,
  setLoadingState,
  setErrorState,
} = checkMediaMTXSlice.actions;
export default checkMediaMTXSlice.reducer;
